
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SEOHead from '../../components/SEO/SEOHead';

export default function ContactPage() {
  const { t } = useTranslation();

  const seoData = {
    title: 'تماس با گلخانه سبز آریا - مشاوره رایگان گلخانه‌سازی | آدرس، تلفن و فرم تماس',
    description: 'تماس با کارشناسان گلخانه سبز آریا برای دریافت مشاوره رایگان گلخانه‌سازی. آدرس دفتر مرکزی تهران، شماره تلفن 02188441386، فرم تماس آنلاین و راه‌های ارتباطی.',
    keywords: 'تماس با گلخانه آریا، شماره تلفن گلخانه آریا، آدرس گلخانه سبز آریا، مشاوره رایگان گلخانه، فرم تماس گلخانه، ارتباط با کارشناسان، دفتر مرکزی تهران، 02188441386، مشاوره تلفنی گلخانه',
    ogImage: 'https://public.readdy.ai/ai/img_res/6727f47dd8146f2a0fa9b3b9d743c027.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "mainEntity": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا",
        "contactPoint": [
          {
            "@type": "ContactPoint",
            "telephone": "۰۲۱۸۸۴۴۱۳۸۶",
            "contactType": "customer service",
            "availableLanguage": ["Persian", "English"],
            "areaServed": "IR",
            "hoursAvailable": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          },
          {
            "@type": "ContactPoint",
            "contactType": "sales",
            "availableLanguage": ["Persian"],
            "areaServed": "IR"
          }
        ],
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IR",
          "addressLocality": "Tehran",
          "addressRegion": "Tehran Province"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "35.6892",
          "longitude": "51.3890"
        }
      }
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center pt-24 mt-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20customer%20service%20contact%20center%20greenhouse%20company%20office%20modern%20workplace%20consultation%20meeting%20room&width=1920&height=600&seq=contact-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">
            تماس با ما
          </h1>
          <p className="text-xl lg:text-2xl max-w-3xl mx-auto">
            مشاوره رایگان و پشتیبانی ۲۴/۷
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">
              راه‌های ارتباط
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              با ما در تماس باشید
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                <i className="ri-phone-line text-emerald-600 ml-2"></i>
                تماس تلفنی
              </h3>
              <div className="space-y-3">
                <div>
                  <span className="text-gray-600">خط ثابت:</span>
                  <span className="font-semibold text-gray-800 mr-2">۰۲۱۸۸۴۴۱۳۸۶</span>
                </div>
                <div>
                  <span className="text-gray-600">شماره همراه مدیر فروش:</span>
                  <span className="font-semibold text-gray-800 mr-2">۰۹۱۲۹۰۹۵۳۰۲</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-3xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                <i className="ri-mail-line text-emerald-600 ml-2"></i>
                ایمیل
              </h3>
              <p className="text-gray-600">
                Montazeri@ariagreenhouse.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
